import { NavLink, Redirect, Route, Switch } from 'react-router-dom';
import UsersPage from './UsersPage/UsersPage';
import PageContainer from 'components/PageContainer/PageContainer';
import { Menu } from 'semantic-ui-react';
import { withDashboardLayout } from 'layouts/DashboardLayout/DashboardLayout';

function WarehouseManagementPage() {
  return (
    <PageContainer
      leftComponent={
        <>
          <h1>Gestión de almacén</h1>
          <Menu pointing secondary>
            <Menu.Item
              as={NavLink}
              activeClassName="active"
              to="/warehouse-management/users"
            >
              Usuarios
            </Menu.Item>
          </Menu>
        </>
      }
    >
      <Switch>
        <Route
          path="/warehouse-management"
          exact
          component={() => <Redirect to="/warehouse-management/users" />}
        />
        <Route path="/warehouse-management/users" exact component={UsersPage} />
      </Switch>
    </PageContainer>
  );
}

export default withDashboardLayout(WarehouseManagementPage);
